import config from "../../config";
const baseUrl = config.baseUrl;

export const ServiceCatagoriesUrls = {

  SERVICECATAGORIES_ADD: baseUrl + "/serivce_categories",
  SERVICECATAGORIES_EDIT: baseUrl + "/serivce_categories",
  SERVICECATAGORIES_STATUS: baseUrl + "/serivce_categories/changedStatus",
  SERVICECATAGORIES_LIST: baseUrl + "/serivce_categories",
  SERVICECATAGORIES_DELETE: baseUrl + "/serivce_categories",
  SERVICECATAGORIES_GETBYID: baseUrl + "/serivce_categories",
  SERVICECATAGORIES_DROPDOWN: baseUrl + "/serivce_categories/dropdown?export=true",
  SERVICECATAGORIES_ROLLBACK: baseUrl + "/serivce_categories/rollback",
  SERVICECATAGORIES_DELETE_HARD: baseUrl + "/serivce_categories",
}